package pt.at.oss.kotlin.manual.schema.importform

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.COMPANY_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.COMPANY_NAME_MIN_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ISSUING_COUNTRY_LEN
import pt.at.oss.kotlin.manual.schema.common.AddressSchema
import pt.at.oss.kotlin.manual.schema.common.VatIdSchema
import pt.at.oss.kotlin.manual.schema.common.bankaccountinfo.BankAccountInfoSchema
import pt.at.oss.kotlin.manual.schema.common.contactinfo.ContactInfoSchema
import pt.at.oss.kotlin.manual.schema.common.contactname.ContactNameSchema
import pt.at.oss.kotlin.manual.schema.common.currvatid.CurrVatIdSchema
import pt.at.oss.kotlin.manual.schema.common.fixedestablishments.FixedEstablishmentsEntrySchema
import pt.at.oss.kotlin.manual.schema.common.relevantdates.RelevantDatesSchema
import pt.at.oss.kotlin.manual.schema.common.tradingnames.TradingNamesEntrySchema
import pt.at.oss.kotlin.manual.schema.common.websites.WebsitesEntrySchema
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.at.oss.kotlin.manual.storage.common.websites.WebsitesEntry
import pt.at.oss.kotlin.manual.storage.importform.ImportForm
import pt.lightweightform.kotlin.schema.ListSchema
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * ImportFormSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class ImportFormSchema : RecordSchema<ImportForm>(name = "import-form") {

    val currVatIdSchema: CurrVatIdSchema = CurrVatIdSchema()
    val intermediaryVatSchema: StringSchema = StringSchema(name = "intermediaryVat")
    val identificationOfBusinessSchema: VatIdSchema = VatIdSchema(name = "identificationOfBusiness", isRequired = true)
    val bankAccountInfoSchema: BankAccountInfoSchema = BankAccountInfoSchema()
    var fixedEstablishmentsSchema: ListSchema<FixedEstablishmentsEntrySchema, FixedEstablishmentsEntry> =
        ListSchema(
            name = "fixedEstablishments",
            childRecordSchema = FixedEstablishmentsEntrySchema()
        )

    //    val registrationSchema: RegistrationSchema = RegistrationSchema()
    val companyNameSchema: StringSchema = StringSchema(name = "companyName", minLength = COMPANY_NAME_MIN_LEN, maxLength = COMPANY_NAME_MAX_LEN)
    var tradingNamesSchema: ListSchema<TradingNamesEntrySchema, TradingNamesEntry> =
        ListSchema(
            name = "tradingNames",
            childRecordSchema = TradingNamesEntrySchema()
        )
    val countryOfBusinessSchema: StringSchema = StringSchema(name = "countryOfBusiness", isRequired = true, minLength = ISSUING_COUNTRY_LEN, maxLength = ISSUING_COUNTRY_LEN)
    val cobRegionSchema: StringSchema = StringSchema(name = "cobRegion", isRequired = false, minLength = ISSUING_COUNTRY_LEN, maxLength = ISSUING_COUNTRY_LEN)
    val addressSchema: AddressSchema = AddressSchema()
    var websitesSchema: ListSchema<WebsitesEntrySchema, WebsitesEntry> =
        ListSchema(
            name = "websites",
            childRecordSchema = WebsitesEntrySchema()
        )
    val contactNameSchema: ContactNameSchema = ContactNameSchema()
    val contactInfoSchema: ContactInfoSchema = ContactInfoSchema()
    var prevOrCurrOssVatIdSchema: ListSchema<VatIdSchema, VatId> =
        ListSchema(
            name = "prevOrCurrOssVatId",
            childRecordSchema = VatIdSchema(name = "prevOrCurrOssVatId", isRequired = true)
        )
    val relevantDatesSchema: RelevantDatesSchema = RelevantDatesSchema()

    override fun isValid(value: ImportForm?): Boolean {
        return value == null || (
            currVatIdSchema.isValid(value.currVatId) &&
                intermediaryVatSchema.isValid(value.intermediaryVat) &&
                identificationOfBusinessSchema.isValid(value.identificationOfBusiness) &&
                bankAccountInfoSchema.isValid(value.bankAccountInfo) &&
                fixedEstablishmentsSchema.isValid(value.fixedEstablishments) &&
                companyNameSchema.isValid(value.companyName) &&
                tradingNamesSchema.isValid(value.tradingNames) &&
                countryOfBusinessSchema.isValid(value.countryOfBusiness) &&
                cobRegionSchema.isValid(value.cobRegion) &&
                addressSchema.isValid(value.address) &&
                websitesSchema.isValid(value.websites) &&
                contactNameSchema.isValid(value.contactName) &&
                contactInfoSchema.isValid(value.contactInfo) &&
                prevOrCurrOssVatIdSchema.isValid(value.prevOrCurrOssVatId) &&
                relevantDatesSchema.isValid(value.relevantDates)
            )
    }

    override fun validate(value: ImportForm?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(currVatIdSchema.validate(value.currVatId, appendToPath(path, "currVatId")))
        validator.addErrors(intermediaryVatSchema.validate(value.intermediaryVat, appendToPath(path, "intermediaryVat")))
        validator.addErrors(identificationOfBusinessSchema.validate(value.identificationOfBusiness, appendToPath(path, "identificationOfBusiness")))
        validator.addErrors(bankAccountInfoSchema.validate(value.bankAccountInfo, appendToPath(path, "bankAccountInfo")))
        validator.addErrors(fixedEstablishmentsSchema.validate(value.fixedEstablishments, appendToPath(path, "fixedEstablishments")))
        validator.addErrors(companyNameSchema.validate(value.companyName, appendToPath(path, "companyName")))

        validator.addErrors(tradingNamesSchema.validate(value.tradingNames, appendToPath(path, "tradingNames")))

        validator.addErrors(countryOfBusinessSchema.validate(value.countryOfBusiness, appendToPath(path, "countryOfBusiness")))
        validator.addErrors(cobRegionSchema.validate(value.cobRegion, appendToPath(path, "cobRegion")))
        validator.addErrors(addressSchema.validate(value.address, appendToPath(path, "address")))

        validator.addErrors(websitesSchema.validate(value.websites, appendToPath(path, "websites")))
        validator.addErrors(contactNameSchema.validate(value.contactName, appendToPath(path, "contactName")))
        validator.addErrors(contactInfoSchema.validate(value.contactInfo, appendToPath(path, "contactInfo")))

        validator.addErrors(prevOrCurrOssVatIdSchema.validate(value.prevOrCurrOssVatId, appendToPath(path, "prevOrCurrOssVatId")))

        validator.addErrors(relevantDatesSchema.validate(value.relevantDates, appendToPath(path, "relevantDates")))
        return validator
    }
}
